import React, { useState, useEffect } from "react";
import { Button } from "antd";
import Table from "../../../Extracomponents/Table";
import Content from "../../../components/Contents/Content";
import Swal from "sweetalert2";
import { GetActiveClientByDateRange } from "../../../Services/Admin/Admin";
import { fDate } from "../../../../Utils/Date_formate";
import { exportToCSV } from "../../../../Utils/ExportData";
import { Tooltip } from "antd";
import { ArrowDownToLine } from "lucide-react";
import { fDateTime } from "../../../../Utils/Date_formate";

const ActiveClientsByDateRange = () => {
  const token = localStorage?.getItem("token");
  const [loading, setLoading] = useState(false);
  const [fromdate, setFromDate] = useState("");
  const [todate, setToDate] = useState("");
  const [data, setData] = useState([]);
  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    setFromDate(today);
    setToDate(today);
  }, []);

  useEffect(() => {
    if (fromdate && todate) {
      handleSearch();
    }
  }, [fromdate, todate]);

  const handleSearch = async () => {
    if (!fromdate || !todate) {
      Swal.fire("Error", "Please select both From Date and To Date", "error");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        fromDate: fromdate,
        toDate: todate,
      };

      const response = await GetActiveClientByDateRange(payload, token);

      if (response?.status && response?.data?.length) {
        setData(response.data);
      } else {
        setData([]);
        Swal.fire("No Data", "No records found", "info");
      }
    } catch (err) {
      console.error(err);
      setData([]);
      Swal.fire("Error", "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadAll = () => {
    if (!data || data.length === 0) {
      Swal.fire("No Data", "Nothing to download", "info");
      return;
    }

    const csvArr = data.map((row, index) => ({
      "S.No": index + 1, // 🔥 Serial Number
      Name: row?.client?.FullName || "N/A",
      Email: row?.client?.Email || "N/A",
      Phone: row?.client?.PhoneNo || "N/A",
      State: row?.client?.state || "N/A",
      City: row?.client?.city || "N/A",
      PAN: row?.client?.panno || "N/A",
      KYCDate: row?.client?.kyc_agreement_date
        ? fDateTime(row.client.kyc_agreement_date)
        : "N/A",
      Plans: row?.plan_titles?.join(", ") || "N/A",
      PlanStart: row?.min_plan_start ? fDateTime(row.min_plan_start) : "N/A",
      PlanEnd: row?.max_plan_end ? fDateTime(row.max_plan_end) : "N/A",
      TotalFees: row?.total_sum || 0,
    }));

    exportToCSV(csvArr, `Active_Clients_${fromdate}_to_${todate}`);
  };

  const columns = [
    {
      name: "S.No",
      selector: (row, index) => index + 1,
      width: "90px",
      center: true,
    },
    {
      name: "Client Name",
      selector: (row) => row?.client?.FullName || "N/A",
      sortable: true,
      width: "200px",
    },
    {
      name: "Email",
      selector: (row) => row?.client?.Email || "N/A",
      width: "200px",
    },
    {
      name: "Phone",
      selector: (row) => row?.client?.PhoneNo || "N/A",
      width: "120px",
    },
    {
      name: "State",
      selector: (row) => row?.client?.state || "N/A",
      width: "150px",
    },
    {
      name: "City",
      selector: (row) => row?.client?.city || "N/A",
      width: "150px",
    },
    {
      name: "PAN",
      selector: (row) => row?.client?.panno || "N/A",
      width: "150px",
    },
    {
      name: "KYC Date",
      selector: (row) =>
        row?.client?.kyc_agreement_date
          ? fDateTime(row.client.kyc_agreement_date)
          : "N/A",
      sortable: true,
      width: "150px",
    },
    {
      name: "Plan Name",
      selector: (row) => row?.plan_titles?.join(", "),
      width: "170px",
    },
    {
      name: "Plan Start",
      selector: (row) => fDateTime(row?.min_plan_start),
      sortable: true,
      width: "150px",
    },
    {
      name: "Plan End",
      selector: (row) => fDateTime(row?.max_plan_end),
      sortable: true,
      width: "150px",
    },
    {
      name: "Total Fees",
      selector: (row) => row?.total_sum,
      right: true,
      width: "120px",
    },
  ];

  return (
    <Content
      Page_title="Active Clients (Date Wise)"
      button_status={false}
      backbutton_status={true}
      backForword={true}
    >
      <div className="page-content">
        <div className="card">
          <div className="card-body">
            <div className="row mb-3 align-items-end">
              <div className="col-md-3">
                <label>From</label>
                <input
                  type="date"
                  className="form-control"
                  value={fromdate}
                  max={today}
                  onChange={(e) => {
                    setFromDate(e.target.value);
                    if (e.target.value > todate) {
                      setToDate(e.target.value);
                    }
                  }}
                />
              </div>

              <div className="col-md-3">
                <label>To</label>
                <input
                  type="date"
                  className="form-control"
                  value={todate}
                  min={fromdate}
                  max={today}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>

              {/* 🔥 THIS IS THE KEY */}
              <div className="col-md-3 ms-auto d-flex justify-content-end">
                <Button
                  type="primary"
                  icon={<ArrowDownToLine size={16} />}
                  onClick={handleDownloadAll}
                >
                  Download
                </Button>
              </div>
            </div>

            <Table columns={columns} data={data} />
          </div>
        </div>
      </div>
    </Content>
  );
};

export default ActiveClientsByDateRange;
